import ProductUrlMappings from './ProductUrlMappings';
const productFromUrl = url => {
  for (const productKey in ProductUrlMappings) {
    if (url && url.search(ProductUrlMappings[productKey].path) > -1) {
      return ProductUrlMappings[productKey];
    }
  }
  return undefined;
};
export default productFromUrl;